const STORAGE_KEY = "global-search-history";
const MAX_ENTRIES = 5;

export function getSearchHistory(): string[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function addSearchHistory(query: string): void {
  const trimmed = query.trim();
  if (!trimmed) return;

  try {
    const history = getSearchHistory().filter(
      (entry) => entry.toLowerCase() !== trimmed.toLowerCase(),
    );
    history.unshift(trimmed);
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(history.slice(0, MAX_ENTRIES)),
    );
  } catch {
    // sessionStorage unavailable (SSR, private browsing quota, etc.)
  }
}

export function clearSearchHistory(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
}
